import styled from 'styled-components';
import vars from '../assets/overwrite-vars.scss';

const CreditText = styled.span`
  font-size: 1rem;
  color: ${vars.grey1};
`;

export default CreditText;
